import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScale = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M5.293 17.584h9.414M4.352 4.404 10 3.463l5.648.941m-11.296 0 2.824 5.649a2.824 2.824 0 1 1-5.649 0l2.825-5.649Zm11.296 0 2.825 5.649a2.825 2.825 0 0 1-5.649 0l2.824-5.649ZM10 1.58v16.004"
	})]
});
const ForwardRef = forwardRef(SvgScale);
export { ForwardRef as ReactComponent };
